import { lazy, type ComponentType } from "react";

export const CHUNK_ERROR_RE = /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|ChunkLoadError/i;

export const isChunkError = (e: unknown) => CHUNK_ERROR_RE.test(String((e as Error)?.message ?? e ?? ""));

/** Lazy com uma nova tentativa para falhas transitórias de rede ao baixar a parte da página. */
export function lazyWithRetry<T extends ComponentType<any>>(load: () => Promise<{ default: T }>, waitMs = 700) {
  return lazy(() =>
    load().catch((e) => {
      if (!isChunkError(e)) throw e;
      return new Promise<{ default: T }>((res, rej) => setTimeout(() => load().then(res, rej), waitMs));
    }),
  );
}
